export { default as Login } from './login/login';
export {default as Dashboard} from "./dashboard/dashboard";
export {default as Report} from "./reports/reports";
export {default as DoctorRetention} from "./doctor-retention/doctor-retention";
export {default as DisplayTrendsData } from "./trends-data/trends-data";
export {default as DownloadExcel} from "./download-excel/download-excel";
export {default as OnboardingStatistics} from "./onboarding-staticstic/onboarding-staticstics";
export {default as MRAnalysis} from "./mr-analysis/mr-analysis";
export {default as SalesDashboard} from "./sales-dashboard/sales-dashbord";